var InputBase = require('../base');

var CheckList = InputBase.extend( {
    /*
    @inputOption = {
        options: 'val1:name1;val2:name;val3:name3',
        multi: true,
        float: true,
        hightlightSelected: false
    }
    */
    create: function( inputOptions, $container ) {
        var self = this
          , $ul = $( '<ul></ul>' ).css( {
                listStyle: 'none', 
                padding: 0, 
                margin: 0, 
                width: '100%',
                overflowX: 'hidden',
                overflowY: 'auto'
            } ).appendTo( $container );
        
        this.$inp = $ul;
        $ul.addClass( inputOptions.vertical ? 'vertical' : 'horizontal' );

        inputOptions.options = (inputOptions.options || '').replace(/;$/, '');

        var options = inputOptions.options ? inputOptions.options.split( ';' ) : [];
        
        if (!options.length) {
            return $ul;
        }

        var opt, $li, items = [];
        
        for ( var i = 0; i < options.length; i++ ) {
            opt = options[i];
            if (!opt) {
                continue;
            }
            items.push( {
                value: opt.split( ':' )[ 0 ],
                displayName: opt.split( ':' )[ 1 ]
            } );
        }
        this.bindData( items );
        
        return $ul;
    },
    getValue: function() {
        var lis = this.$inp.find( '>li[checked]' ), values = [];
        lis.each( function() {
            values.push( $( this ).attr( 'val' ) );
        } );
        return values;
    },
    getDisplayName: function() {
        var lis = this.$inp.find( '>li[checked]' ), values = [];
        lis.each( function() {
            values.push( $( this ).text() );
        } );
        return values;
    },
    setValue: function( value ) {
        if ( typeof value === 'string' ) {
            value = value.split( /(,\s*)|(;\s*)/g );
        }
        var $lis = this.$inp.find( '>li[checked]' ).removeAttr( 'checked' );
        if ( this.model.inputOptions.hightlightSelected ) {
            $lis.removeClass( 'ui-state-active' );
        }
        $lis.find( '>span' ).removeClass( 'ui-icon' ).removeClass( 'ui-icon-check' );
        for ( var i in value ) {
            this.$inp.find( '>li[val=' + value[i] + ']' ).attr( 'checked', 'checked')
                .find('>span' ).addClass( 'fa' ).addClass( 'fa-check' );
            
        }
        return this
    },
    bindData: function( data ) {
        if (!data) {
            return;
        }
        var $ul = this.$inp.html( '' );
        var inputOptions = this.model.inputOptions;
        var self = this;
        for ( var i = 0; i < data.length; i++ ) {
            $li = $('<li>').text( data[ i ].displayName )
                .appendTo( $ul )
                .attr( 'val', data[ i ].value );
            $( '<span>' )
                .addClass('ui-widget-content')
                .appendTo( $li )
                .click( function( e ) {
                    if ( !inputOptions.multi ) {
                        var $lis = $(this).parent().parent().find( '>li[checked]' )
                            .removeAttr( 'checked' );
                        if ( inputOptions.hightlightSelected ) {
                            $lis.removeClass( 'ui-state-active' );
                        }
                        $lis.find( '>span' ).removeClass( 'fa' )
                            .removeClass( 'fa-check' );
                    }
                    var $l = $(this).parent();
                    if ( $l.attr( 'checked' ) ) {
                        $l.removeAttr( 'checked' );
                        if ( inputOptions.hightlightSelected ) { 
                            $l.removeClass( 'ui-state-active' );
                        }
                        $(this).removeClass( 'fa' ).removeClass( 'fa-check' );
                    } else {
                        $l.attr( 'checked', true );
                        if ( inputOptions.hightlightSelected ) {
                            $l.addClass( 'ui-state-active' );
                        }
                        $(this).addClass( 'fa' ).addClass( 'fa-check' );
                    }
                    self.check();
                    self.trig( 'Check' );
                    e.stopPropagation();
                } );
        }
        
        // if ( this.prof.inputOptions['float'] ) {
        //     $ul.children().css( 'float', 'left' );
        // }
        return this;
    },
    bindCheckEvent: function( eventName ) {
        
    }
} );

module.exports = CheckList;


//////////////////
// WEBPACK FOOTER
// ./src/input-factory/checklist/index.js
// module id = 12
// module chunks = 0